import React from 'react'
import styled from 'styled-components'
import { colors, _ } from 'utils'
import Icon from './Icon'
import { IconOption } from './Icon/icons'

export enum LocationType {
    VIRTUAL = 'VIRTUAL',
    IN_PERSON = 'IN_PERSON',
    HYBRID = 'HYBRID',
}

export type LocationTypeKeys = keyof typeof LocationType

export const getLocationTypeTranslation = (location: LocationTypeKeys) => ({
    [LocationType.VIRTUAL]: _('program_calendar.location_type.virtual'),
    [LocationType.IN_PERSON]: _('program_calendar.location_type.in_person'),
    [LocationType.HYBRID]: _('program_calendar.location_type.hybrid'),
}[location])

const S = {
    Wrapper: styled.div`
        display: flex;
        width: 72px;
        align-items: center;
        flex-shrink: 0;
        font-size: 12px;
        color: ${colors.icon};
        text-transform: uppercase;
    `,
}

const iconMapper: Record<LocationTypeKeys, IconOption> = {
    VIRTUAL: 'virtual',
    IN_PERSON: 'handShake',
    HYBRID: 'hybrid',
}

const LocationIndicator = ({ location, className }: { location: LocationTypeKeys, className?: string }) => (
    <S.Wrapper className={className}>
        {iconMapper[location] && <Icon icon={iconMapper[location]} size={18} className="mr-1" />}
        {getLocationTypeTranslation(location)}
    </S.Wrapper>
)

export default LocationIndicator
